import { createSelector } from 'reselect'
import _ from 'lodash';

export const getState = (state) => {
  return {state: state.auth};
};

export const getParamState = (state, params) => {
  return {state: state.auth, params: params};
};

export const getResponse = createSelector(
  (state, params) => getParamState(state, params),
  ({state, params}) => {
    return state[params.id];
  }
);

export const isLoggedIn = (state) => state.auth.loginData && state.auth.loginData.token != null;
export const loginData = (state) => state.auth.loginData;
export const authToken = (state) => state.auth.loginData ? state.auth.loginData.token : null;
export const registrationError = (state) => state.auth.registrationError;
export const currentTenantId = (state) => state.auth.currentTenantId || (state.auth.loginData ? state.auth.loginData.tenant_id : null);



// WEBPACK FOOTER //
// ./src/storeState/auth/selectors.js